export interface AttachmentFileLike {
  url?: string | null;
  mdUrl?: string | null;
  lgUrl?: string | null;
  processed?: boolean;
}

// Full-resolution image URL for a photo viewer modal, preferring the largest
// available variant. Returns null while the image is still processing.
export function resolveViewerSrc(file?: AttachmentFileLike | null): string | null {
  if (!file || !file.processed) return null;
  return file.lgUrl || file.mdUrl || file.url || null;
}

export function clampPrevIndex(index: number): number {
  return index > 0 ? index - 1 : index;
}

export function clampNextIndex(index: number, length: number): number {
  return index < length - 1 ? index + 1 : index;
}
